import AssetCardList from './AssetCardList';

export default AssetCardList;
